import { UserGroup } from "../user-management/types";
import {
	MobileRaiseTemplate,
	RaiseId,
	TemplateDetailsModel,
	TemplateGridRowModel,
	MobileRaiseLink,
	MobileRaiseLinkEditModel,
	MobileRaise
} from "./types";

export const raiseIdsEqual = (id1: RaiseId, id2: RaiseId): boolean => {
	return id1.objectID === id2.objectID && id1.manualRaiseType === id2.manualRaiseType;
};

export const newTemplateDetailsModel = (): TemplateDetailsModel => ({
	title: "",
	quickSelectRaises: 4,
	userGroups: [],
	mobileRaiseLinks: []
});

export type UserGroupGetter = (id: number) => UserGroup | undefined;
export type RaiseGetter = (id: RaiseId) => MobileRaise | undefined;

export const createMapTemplateToRowMapper = (userGroupGetter: UserGroupGetter) => (
	t: MobileRaiseTemplate
): TemplateGridRowModel => ({
	mobileRaiseTemplateID: t.mobileRaiseTemplateID,
	title: t.title,
	userGroups: t.userGroupIDs.map(id => {
		const userGroup = userGroupGetter(id);
		return userGroup ? userGroup.title : "";
	}),
	quickSelectRaises: t.gridSet.toString()
});

export const createMapTemplateToDetailsMapper = (userGroupGetter: UserGroupGetter, raiseGetter: RaiseGetter) => (
	t: MobileRaiseTemplate
): TemplateDetailsModel => {
	const model: TemplateDetailsModel = {
		mobileRaiseTemplateID: t.mobileRaiseTemplateID,
		title: t.title,
		userGroups: t.userGroupIDs.map(id => userGroupGetter(id)),
		quickSelectRaises: t.gridSet,
		mobileRaiseLinks: t.mobileRaiseLinks.map(createMapMobileRaiseLinkToEditModelMapper(raiseGetter))
	};
	return model;
};

const createMapMobileRaiseLinkToEditModelMapper = (raiseGetter: RaiseGetter) => (
	l: MobileRaiseLink
): MobileRaiseLinkEditModel => {
	const raise = raiseGetter(l);
	return {
		...l,
		titleList: raise ? raise.titleList : []
	};
};

export const mapDetailsModelToTemplate = (model: TemplateDetailsModel): MobileRaiseTemplate => {
	const template: MobileRaiseTemplate = {
		title: model.title,
		mobileRaiseLinks: model.mobileRaiseLinks.map(l => ({
			objectID: l.objectID,
			manualRaiseType: l.manualRaiseType,
			gridSetSlot: l.gridSetSlot,
			iconSetID: l.iconSetID
		})),
		userGroupIDs: model.userGroups.map(ug => ug.userGroupId),
		gridSet: model.quickSelectRaises,
		mobileRaiseTemplateID: model.mobileRaiseTemplateID ?? 0
	};
	return template;
}
